/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { SplitText } from "gsap/SplitText";
import { CustomEase } from "gsap/CustomEase";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger,ScrollSmoother,SplitText,CustomEase,ScrollToPlugin);
import imagesLoaded from 'imagesloaded';
// import Cookies from 'vendor/cookies';
require('./vendor/animsition.js');

// Anchor example
// smoother.scrollTo(".box-c", true, "center center");

// Cursor stuff
// import Cursor from "./modules/cursor";
import Magnetic from "./modules/magnetic";

imagesLoaded(document.querySelector('body'), function (instance) {
  // Load stuff after all the images in the body load
  // ScrollTrigger.refresh();
});

import { challengeAnimations } from './modules/challengeAnimations';

function animateNext() {
  $('.next__button').on('mouseenter', () => {
    $('.next').addClass('hovering');
  }).on('mouseleave', () => {
    $('.next').removeClass('hovering').addClass('unhovered');
  });
}

const titles = document.querySelectorAll(".splitText");

function setupSplits() {
  titles.forEach(title => {
    // Reset if needed
    if(title.anim) {
      title.anim.progress(1).kill();
      title.split.revert();
    }

    title.split = new SplitText(title, {
      type: "lines,words",
      linesClass: "split-line"
    });

    // Set up the anim
    title.anim = gsap.from(title.split.words, {
      scrollTrigger: {
        trigger: title,
        toggleActions: "restart pause resume reverse",
        start: "top 50%",
        // markers: true
      },
      duration: 1,
      ease: "circ.out",
      y: '110%',
      stagger: 0.05,
    });

    // $('.hero__title').addClass('animated');
  });

  setTimeout(() => {
    $('.reportTitle__title').addClass('animated');
  }, 500);
}

// Animate On Scroll
import { animateOnScroll } from './modules/animateOnScroll.js';

// Don't load on mobile
function is_touch_enabled() {
  return ( 'ontouchstart' in window ) ||
         ( navigator.maxTouchPoints > 0 ) ||
         ( navigator.msMaxTouchPoints > 0 );
}

import { chartsSlider } from './modules/chartsSlider';
var chartSliderExists = document.querySelector('.charts__slider');
if (chartSliderExists) {
  var donutRevenueEl = document.getElementById("donut-revenue").getContext("2d");
  function donutRevenueGraph() {
    var donutRevenue = new Chart(donutRevenueEl).Doughnut(
      // Datas
      [
        {
          value: 43,
          color:"#BF0E1E",
          highlight: "#BF0E1E",
          label: "Charter Fees"
        },
        {
          value: 47,
          color: "#98020F",
          highlight: "#98020F",
          label: "Programs, Products, Services"
        },
        {
          value: 3,
          color: "#767474",
          highlight: "#767474",
          label: "Advertising/Miscellaneous"
        },
        {
          value: 0.65,
          color: "#908A8A",
          highlight: "#908A8A",
          label: "OSHA Grant"
        },
        {
          value: 6.35,
          color: "#FF0016",
          highlight: "#FF0016",
          label: "Construction Advocacy Fund"
        }
      ],
      // Options
      {
        segmentShowStroke : false,
        segmentStrokeWidth : 2,
        percentageInnerCutout : 70,
        animationSteps : 150,
        animationEasing : "easeOutQuart",
        animateRotate : true,
        animateScale : false,
        responsive: true,
        maintainAspectRatio: true,
        showScale: true,
        animateScale: true
      }
    );
  }
  // donutRevenueGraph();

  var donutSpendEl = document.getElementById("donut-spend").getContext("2d");
  function donutSpendGraph() {
    var donutSpend = new Chart(donutSpendEl).Doughnut(
      // Datas
      [
        {
          value: 52.64,
          color:"#98020F",
          highlight: "#98020F",
          label: "Chapter support"
        },
        {
          value: 30.13,
          color: "#BF0E1E",
          highlight: "#BF0E1E",
          label: "government ia"
        },
        {
          value: 12.68,
          color: "#FF0016",
          highlight: "#FF0016",
          label: "GA Support Services"
        },
        {
          value: 4.54,
          color: "#767474",
          highlight: "#767474",
          label: "Association Leadership"
        }
      ],
      // Options
      {
        segmentShowStroke : false,
        segmentStrokeWidth : 2,
        percentageInnerCutout : 70,
        animationSteps : 150,
        animationEasing : "easeOutQuart",
        animateRotate : true,
        animateScale : false,
        responsive: true,
        maintainAspectRatio: true,
        showScale: true,
        animateScale: true
      }
    );
  }
  // donutSpendGraph();

  var donutExpensesEl = document.getElementById("donut-expenses").getContext("2d");
  function donutExpensesGraph() {
    var donutExpenses = new Chart(donutExpensesEl).Doughnut(
      // Datas
      [
        {
          value: 50,
          color:"#98020F",
          highlight: "#98020F",
          label: "Charter Fees"
        },
        {
          value: 3,
          color: "#908A8A",
          highlight: "#908A8A",
          label: "Programs, Products, Services"
        },
        {
          value: 7,
          color: "#ED6C72",
          highlight: "#ED6C72",
          label: "Advertising/Miscellaneous"
        },
        {
          value: 2,
          color: "#B6B1B1",
          highlight: "#B6B1B1",
          label: "OSHA Grant"
        },
        {
          value: 1,
          color: "#D0D0D0",
          highlight: "#D0D0D0",
          label: "Construction Advocacy Fund"
        },
        {
          value: 5,
          color: "#767474",
          highlight: "#767474",
          label: "Construction Advocacy Fund"
        },
        {
          value: 24,
          color: "#B02828",
          highlight: "#B02828",
          label: "Construction Advocacy Fund"
        },
        {
          value: 1,
          color: "#444",
          highlight: "#444",
          label: "Construction Advocacy Fund"
        },
        {
          value: 7,
          color: "#FF0016",
          highlight: "#FF0016",
          label: "Construction Advocacy Fund"
        }
      ],
      // Options
      {
        segmentShowStroke : false,
        segmentStrokeWidth : 2,
        percentageInnerCutout : 70,
        animationSteps : 150,
        animationEasing : "easeOutQuart",
        animateRotate : true,
        animateScale : false,
        responsive: true,
        maintainAspectRatio: true,
        showScale: true,
        animateScale: true
      }
    );
  }
  // donutExpensesGraph();

  var donutProductsEl = document.getElementById("donut-products").getContext("2d");
  function donutProductsGraph() {
    var donutProducts = new Chart(donutProductsEl).Doughnut(
      // Datas
      [
        {
          value: 24.23,
          color:"#8B1B19",
          highlight: "#8B1B19",
          label: "Charter Fees"
        },
        {
          value: 6.06,
          color: "#D0D0D0",
          highlight: "#D0D0D0",
          label: "Programs, Products, Services"
        },
        {
          value: 12.35,
          color: "#767474",
          highlight: "#767474",
          label: "Advertising/Miscellaneous"
        },
        {
          value: 21.43,
          color: "#B02828",
          highlight: "#B02828",
          label: "OSHA Grant"
        },
        {
          value: 7.44,
          color: "#8F8A8A",
          highlight: "#8F8A8A",
          label: "Construction Advocacy Fund"
        },
        {
          value: 6.70,
          color: "#B6B1B1",
          highlight: "#B6B1B1",
          label: "Construction Advocacy Fund"
        },
        {
          value: 0.85,
          color: "#ffffff",
          highlight: "#ffffff",
          label: "Construction Advocacy Fund"
        },
        {
          value: 20.94,
          color: "#EB332B",
          highlight: "#EB332B",
          label: "Construction Advocacy Fund"
        }
      ],
      // Options
      {
        segmentShowStroke : false,
        segmentStrokeWidth : 2,
        percentageInnerCutout : 70,
        animationSteps : 150,
        animationEasing : "easeOutQuart",
        animateRotate : true,
        animateScale : false,
        responsive: true,
        maintainAspectRatio: true,
        showScale: true,
        animateScale: true
      }
    );
  }
  // donutProductsGraph();

  chartsSlider();

  ScrollTrigger.create({
    trigger: ".charts",
    once: true,
    onEnter: function(){
      donutRevenueGraph();
      donutSpendGraph();
      donutExpensesGraph();
      donutProductsGraph();
    },
    start: 'top 35%',
  });
}



// Mobile vs. Desktop controls
if( ! is_touch_enabled() ) {
  // Set up cursor
  // const cursor = new Cursor();
  $('[data-magnetic]').each(function () {new Magnetic(this);});

  $('#smooth-wrapper').addClass('nonTouch');
  animateOnScroll();
  setupSplits();
  challengeAnimations();
  animateNext();

  var largeTL = gsap.timeline({
    scrollTrigger: {
      trigger: '.challenges',
      pin: '.challenges__bg',
      pinSpacing: false,
      start: "top top",
      // markers: true,
      endTrigger: '.last',
      end: 'bottom bottom'
    },
  });
  let smoother = ScrollSmoother.create({
    smooth: 2,               // how long (in seconds) it takes to "catch up" to the native scroll position
    effects: true,           // looks for data-speed and data-lag attributes on elements
    normalizeScroll: {allowNestedScroll: true}
  });

  gsap.utils.toArray(".anchor").forEach(function (button, i) {
    button.addEventListener("click", (e) => {
      var id = e.target.getAttribute("href");
      smoother.scrollTo(id, true, "top top");
      e.preventDefault();
    });
  });

  let urlHash = window.location.href.split("#")[1];
  let scrollElem = document.querySelector("#" + urlHash);

  if (urlHash && scrollElem) {
    gsap.to(smoother, {
      scrollTop: smoother.offset(scrollElem, "top top"),
      duration: 0.5
    });
  }

  const showAnim = gsap.from('.siteHeader', {
    yPercent: -100,
    paused: true,
    duration: 0.2
  }).progress(1);

  ScrollTrigger.create({
    // scroller: smoother,
    start: "top top",
    end: 99999,
    onUpdate: (self) => {
      self.direction === -1 ? showAnim.play() : showAnim.reverse()
    }
  });


  // ScrollTrigger.addEventListener("refresh", setupSplits);

} else {
  $('body').addClass('touch');
}

import { mobileNav } from './modules/mobileNav';
mobileNav();

import { popup } from './modules/popup';
var popupExists = document.querySelector('.popupLink');
if (popupExists) {
  popup();
}

import { popupVideo } from './modules/popupVideo';
var popupVideoExists = document.querySelector('.playVideo');
if (popupVideoExists) {
  popupVideo();
}

// Refire stuff on window resize
var timeout = false, // holder for timeout id
    delay   = 250; // delay after event is "complete" to run callback

// window.resize event listener
window.addEventListener('resize', function () {
  // clear the timeout
  clearTimeout(timeout);
  // start timing for event "completion"
  timeout = setTimeout(function () {
    ScrollTrigger.refresh();
  }, delay);
});


import { homePageAnimation } from './modules/homePageAnimation';
var homePageAnimationExists = document.querySelector('.home');
if (homePageAnimationExists) {
  homePageAnimation();
}

$('.financials__navLi').on('click', function() {
  var target = $(this).attr('data-section-target');
  // alert(target);
  $('.financials__navLi').removeClass('active');
  $(this).addClass('active');

  // First, hide 'em
  $('.financials__bars').addClass('hiding');
  $('.financials__bars').removeClass('active');

  setTimeout(() => {
    $('.financials__bars[data-bar-id=' + target + ']').removeClass('hiding');
    $('.financials__bars[data-bar-id=' + target + ']').addClass('active');
  }, 600);
});

$('.charts__navLi').on('click tap', function() {
  $('.charts__navLi').removeClass('active');
  $(this).addClass('active');
});

// $(document).ready(function() {
//   $(".animsition-overlay").animsition({
//     inClass: 'overlay-slide-in-bottom',
//     outClass: 'overlay-slide-out-bottom',
//     inDuration: 750,
//     outDuration: 750,
//     linkElement: 'a:not([target="_blank"]):not([href^="#"]):not(".playVideo"):not(".popupLink"):not([href="/"])',
//     // e.g. linkElement: 'a:not([target="_blank"]):not([href^="#"])'
//     loading: true,
//     loadingParentElement: 'body', //animsition wrapper element
//     loadingClass: 'animsition-loading',
//     loadingInner: '', // e.g '<img src="loading.svg" />'
//     timeout: false,
//     timeoutCountdown: 5000,
//     onLoadEvent: true,
//     browser: [ 'animation-duration', '-webkit-animation-duration'],
//     // "browser" option allows you to disable the "animsition" in case the css property in the array is not supported by your browser.
//     // The default setting is to disable the "animsition" in a browser that does not support "animation-duration".
//     overlay : true,
//     overlayClass : 'animsition-overlay-slide',
//     overlayParentElement : 'body',
//     transition: function(url){ window.location.href = url; }
//   });
// });
